import { Vehicle } from "@tm/models"
import { ajaxAuth, mapVehicle } from "@tm/utils"
import { getVehicleGsiServiceUrl } from "@tm/data/vehicles/gsi/helper"

export function loadVehicle(id: string): Promise<Vehicle> {
    return new Promise<Vehicle>((resolve, reject) => {
        ajaxAuth({
            url: `${getVehicleGsiServiceUrl()}/ShowVehicle`,
            body: { id },
        }).then((response) => {
            if (response) {
                resolve(mapVehicle(response))
            } else {
                reject()
            }
        }, reject)
    })
}
